import './index.less';

import request from '@/utils/request';
import { getLocaleText, setSearchHistory } from '@/utils/utils';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import { Toast } from 'antd-mobile';
import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { getLocale, history } from 'umi';
import Verify from '../Verify';
import SureEmail from '../SureEmail';

// import Verify from './Verify';

let timelock: any = null;
const Email = (props: any) => {
  const { setEmailVisble } = props;
  const [verifyVisable, setVeryfiVisable] = useState(false);
  const [sureVisable, setSureVisable] = useState(false);
  const [email, setEmail] = useState<any>(null);
  const [code, setCode] = useState<any>();
  const [picData, setPicData] = useState<any>();
  const [picCode, setPicCode] = useState<any>();
  const intl = useIntl();
  const [countdownSeconds, setCountdownSeconds] = useState(0);
  const [isActive, setIsActive] = useState(false);

  // 关闭验证码弹窗
  const verifyClose = () => {
    setVeryfiVisable(false);
  };
  // 关闭确认弹窗
  const sureClose = () => {
    setSureVisable(false);
  };

  useEffect(() => {
    let intervalId: any;
    if (isActive && countdownSeconds > 0) {
      intervalId = setInterval(() => {
        setCountdownSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    } else if (isActive && countdownSeconds === 0) {
      setIsActive(false);
    }

    return () => clearInterval(intervalId);
  }, [isActive, countdownSeconds]);

  // 校验澳门手机号
  function validateEmail(email: any) {
    const macaoPhoneRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return macaoPhoneRegex.test(email);
  }
  // 打开图形验证码弹窗（获取验证码按钮）
  const verify = () => {
    const isValidEmail = validateEmail(email);
    if (isValidEmail) {
      setVeryfiVisable(true);
      clearInterval(timelock);
      timelock = null;
    } else {
      Toast.info(
        intl.formatMessage({
          id: 'mytv.page.enterValidEmailAddress',
        }),
      );
    }
  };
  // 校验图形验证码并获取验证码
  const checkImgCode = async () => {
    const Url = `${process.env.BMSUrl}bms/user/ctmlogin/getCode`;
    const res = await request.post(Url, {
      data: {
        lang: `${getLocale().replace(/-/gi, '_')}`,
        areaCode: '853',
        platformCode: `${process.env.BMSsiteId}`,
        accountId: localStorage.getItem('accountId'),
        version: 1,
        picUuid: picData.picUuid,
        picCode: picCode,
      },
    });
    if (res?.code === 200) {
      setCountdownSeconds(180);
      setIsActive(true);
    } else {
      Toast.info(res?.mes);
    }
  };
  // 打开确认弹窗
  const sure = async () => {
    if (!email) {
      Toast.info(
        // '請輸入Email地址',
        intl.formatMessage({
          id: 'mytv.page.enterEmailAddressPrompt',
        }),
      );
    } else if (!code) {
      Toast.info(
        // '請輸入驗證碼',
        intl.formatMessage({
          id: 'mytv.page.enterVerificationCode',
        }),
      );
    } else {
      const Url = `${process.env.BMSUrl}bms/user/ctmlogin/chechCode`;
      const res = await request.post(Url, {
        data: {
          version: 1,
          lang: `${getLocale().replace(/-/gi, '_')}`,
          userCode: code,
          accountId: localStorage.getItem('accountId'),
          userId: localStorage.getItem('userId'),
          userToken: localStorage.getItem('userToken'),
          mac: '1234567890',
          // terminalType: 4,
        },
      });
      if (res?.code === 200) {
        setSureVisable(true);
      } else {
        Toast.info(res?.mes);
      }
    }
  };
  return (
    <div>
      <Dialog
        className="email"
        open={true}
        // title='首次觀看myTV內容需添加Email賬號'
        // onClose={handleClose}
        aria-labelledby="form-dialog-title"
        disableBackdropClick={true}
      >
        <div className="content">
          <div className="left">
            {' '}
            <DialogContent>
              <DialogContentText>
                {getLocaleText('mytv.page.firstTimeWatch')}
              </DialogContentText>
              <div className="phone">
                <span>{getLocaleText('mytv.page.account')}</span>

                <div>
                  {localStorage
                    .getItem('accountId')
                    .replace(/^(\d{2})\d*(\d{2})$/, '$1****$2')}
                </div>
              </div>
              <div className="phone">
                <span>{getLocaleText('mytv.page.emailAddress')}</span>

                <TextField
                  value={email}
                  autoFocus
                  margin="dense"
                  id="name"
                  onChange={(v) => setEmail(v.target.value)}
                  // label="Email Address"
                  type="email"
                  fullWidth
                  // error
                  // helperText="Incorrect entry."
                />
              </div>
              <div className="phone">
                <span>
                  {getLocaleText('mytv.page.phoneNumberVerification')}
                </span>

                <TextField
                  value={code}
                  autoFocus
                  margin="dense"
                  id="name"
                  onChange={(v) => setCode(v.target.value)}
                  // type="email"
                  fullWidth
                  style={{ width: '30%' }}
                />
                <div className="seconds">
                  <div onClick={verify} color="primary">
                    {isActive
                      ? ` ${countdownSeconds}s${getLocaleText(
                          'mytv.page.retryAfter',
                        )}`
                      : `${getLocaleText('mytv.page.getVerificationCode')}`}
                  </div>
                </div>
              </div>
              <div className="text">
                {getLocaleText('mytv.page.emailNotice')}
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  sure();
                }}
                color="primary"
              >
                {getLocaleText('mytv.page.confirm')}
              </Button>
              <Button
                className="cancel"
                onClick={() => {
                  setEmailVisble(false);
                }}
                color="primary"
              >
                {getLocaleText('mytv.page.cancel')}
              </Button>
            </DialogActions>
          </div>
        </div>
      </Dialog>
      {verifyVisable && (
        <Verify
          visable={verifyVisable}
          close={verifyClose}
          phone={localStorage.getItem('accountId')}
          type="email"
          setPicData={setPicData}
          checkEmailImgCode={checkImgCode}
          setPicCode={setPicCode}
        />
      )}
      {sureVisable && (
        <SureEmail
          email={email}
          close={sureClose}
          visable={sureVisable}
          setEmailVisble={setEmailVisble}
        ></SureEmail>
      )}
    </div>
  );
};

export default Email;
